import Env from '../../base/env'
import gsap from 'gsap'

export default class Haikus
{
  constructor(view)
  {
    this.view = view
    this.$collection = this.view.querySelector('.jsCollection')
    this.btnMore = this.view.querySelector('.jsMore')
    this.datas = JSON.parse(this.view.querySelector('.jsData').value)
    this.$item1 = this.view.querySelector('.jsItem1')
    this.$item2 = this.view.querySelector('.jsItem2')
    this.$animates = [this.$item1,this.$item2]
    this.TOTAL = this.datas.length - 1
    this.CURRENT_INDEX = 0
    //
    this.randomize()
    this.events()
    this.eventsShare()
    this.display()
  }

  animate()
  {
    const tl = gsap.timeline()

    tl.add(
      gsap.fromTo(this.$animates , { autoAlpha: 1 , y : 0 } , { autoAlpha : 0 , stagger:.1, ease: 'power3.out' , duration : .5 })
    )
    tl.add(()=>{
      this.display()
    })
    tl.add(
      gsap.fromTo(this.$animates , { y : 20 } , { immediateRender:false, autoAlpha : 1 , y : 0 , stagger:.1, ease: 'power3.out' , duration : 1 })
    ,'+=.2')
  }

  display()
  {
    if(typeof this.rDatas[this.CURRENT_INDEX] != 'undefined') {
      const item1 = this.template(this.rDatas[this.CURRENT_INDEX])
      this.$item1.innerHTML = item1
    } else {
      this.$item1.innerHTML = ''
    }
    if(typeof this.rDatas[this.CURRENT_INDEX + 1] != 'undefined') {
      const item2 = this.template(this.rDatas[this.CURRENT_INDEX + 1])
      this.$item2.innerHTML = item2
    } else {
      this.$item2.innerHTML = ''
    }
    this.eventsShare()
  }

  eventsShare()
  {
    this.$triggers = this.view.querySelectorAll('.jsTrigger')
    for (let $trigger of this.$triggers) {
      $trigger.addEventListener('click',()=>{
        const getUrl = $trigger.getAttribute("data-url")
        Env.framework.toolbox.openCenteredWindow({
          url: getUrl,
          width: 600,
          height: 600
        }).focus()
      })
    }
  }

  events()
  {


    this.btnMore.addEventListener('click',()=>{
      if(Env.mobileCSS == true) {
        this.CURRENT_INDEX++
      } else {
        this.CURRENT_INDEX+=2
      }

      if(this.CURRENT_INDEX > this.TOTAL) {
        this.CURRENT_INDEX = 0
      }
      this.animate()
    })
  }

  randomize()
  {
    this.rDatas = Env.framework.toolbox.shuffled(this.datas);
  }

  template(data)
  {
    const html = `
    <figure class="main-visual">
      <div class="tw-overflow-hidden">
        <img src="${ data.visual }" alt="${ data.alt }" class="fx-hoverscale">
      </div>
      <figcaption class="caption">${ data.caption }</figcaption>
    </figure>
    <button class="tw-mt-10 tw-text-left tw-opacity-100 hover:tw-opacity-60 tw-transition-opacity focus:tw-outline-none focus:tw-ring-0 jsTrigger" data-url="${ data.share_url }">
      <span class="icon-twitter tw-text-ebonyclay tw-text-base"></span>
      <span class="text tw-block tw-uppercase tw-font-norms-rg tw-text-mineshaft tw-tracking-wider tw-text-xxs">${ trans.cta_share}</span>
    </button>`
    return html
  }
}
